import {getDescendants} from '@packages/utilities/core-elements';
import {isFormPlaceholder} from '@packages/utilities/elementTypeUtils';
import {type ExpressionElement} from '@packages/systems/wfdl-ast';

/**
 * True for a form placeholder with nothing in it yet: where a campaign page
 * waits for the HubSpot or Marketo app to connect a form.
 */
export const isEmptyFormPlaceholder = (element: ExpressionElement): boolean =>
  isFormPlaceholder(element) && getDescendants(element).length === 0;
